<template>
  <v-layout row wrap justify-center>
    <v-card class="shadow flex xs12">
      <v-card-text class="pt-1">
        <div class="flex-row align-center justify-start pt-2">
          <v-spacer />
          <v-text-field
            outline
            hide-details
            v-model="search"
            style="max-width:400px"
            class="flex xs12 rounded"
            :placeholder="$t('search')"
            prepend-inner-icon="search"
          />
          <v-btn
            color="grey darken-2"
            class="ml-0"
            flat
            icon
            @click="printTable(false)"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn
            color="grey darken-2"
            class="mx-0"
            flat
            icon
            @click="printTable(true)"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
        </div>

        <v-data-table
          ref="tbl"
          :search="search"
          :headers="headers"
          :items="dailyProfits"
        >
          <template slot="items" slot-scope="{ item, index }">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>{{ item.date | persianDateFilter }}</td>
              <td>{{ item.time }}</td>
              <td
                :class="{
                  'red--text': item.commissions < 0,
                  'activeColor--text': item.commissions > 0,
                }"
              >
                {{ item.commissions | currency }}
              </td>
              <td
                :class="{
                  'red--text': item.exchanges < 0,
                  'activeColor--text': item.exchanges > 0,
                }"
              >
                {{ item.exchanges | currency }}
              </td>
              <td
                :class="{
                  'red--text font-weight-bold': item.balance < 0,
                  'activeColor--text font-weight-bold': item.balance > 0,
                }"
              >
                {{ item.balance | currency }}
              </td>
              <td>
                <v-btn
                  icon
                  flat
                  small
                  class="ma-0"
                  color="grey darken-1"
                  @click="deleteItem(item)"
                  v-if="userCan('change_rate')"
                >
                  <v-icon>delete_outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  name: "DailyProfitsTable",
  props: {
    dailyProfits: { default: () => [] },
  },

  data: () => ({
    search: "",
    dialog: false,
    editIndex: -1,
    editDialog: false,
  }),
  computed: {
    headers: (vm) => {
      let items = [
        {
          value: "index",
          width: "30px",
          sortable: false,
          text: vm.$t("number"),
        },
        {
          value: "date",
          sortable: false,
          text: vm.$t("date"),
          computed: (item) => vm.persianDateFilter(item.date),
        },
        {
          value: "time",
          sortable: false,
          text: vm.$t("time"),
        },
        {
          sortable: false,
          value: "commissions",
          text: vm.$t("commissions"),
        },
        {
          sortable: false,
          value: "exchanges",
          text: vm.$t("exchanges"),
        },
        {
          sortable: false,
          value: "balance",
          text: vm.$t("balance"),
        },
        {
          width: "100px",
          sortable: false,
          text: vm.$t("actions"),
        },
      ];
      return items;
    },
  },
  methods: {
    deleteItem(item) {
      let vm = this;
      this.$alert("daily-profits/" + item.id).then(() => {
        vm.computedItems.splice(vm.computedItems.indexOf(item), 1);
        vm.$emit("saved");
      });
    },

    printTable(excel) {
      let data = {
        items: this.$refs.tbl.filteredItems,
        headers: this.headers.slice(1, -1),
        title: "لیست فواید روزانه",
      };

      if (excel) return this.xl_tables(data, "daily-profits",this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },
};
</script>
